import { Outlet } from 'react-router-dom';

import { useAppSelector, useAppDispatch } from 'hooks';

// project imports
import SessionAlertDialog from 'ui-components/SessionAlertDialog';
import Header from './Header';
import Sidebar from './Sidebar';
import { setMenu } from 'store/menuReducer';

import './layout.css';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
    const opened = useAppSelector((state) => state.menu.opened);
    const dispatch = useAppDispatch();

    const handleLeftDrawerToggle = () => {
        dispatch(setMenu(!opened));
    };

    return (
        <div className={`gd-shell ${opened ? 'gd-shell--open' : 'gd-shell--closed'}`}>
            <SessionAlertDialog />
            <Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
            <Sidebar />
            <button type="button" className="gd-shell__backdrop" aria-label="Close menu" onClick={handleLeftDrawerToggle} />
            <main className="gd-main">
                <Outlet />
            </main>
        </div>
    );
};

export default MainLayout;
